import { isAxiosError as a } from "axios";
import i from "./isCodedError.mjs";
import n from "./isAPIError.mjs";
import "@ancon/wildcat-types";
function o(s) {
  var e, t;
  return {
    message: s.message,
    code: s.code,
    response: {
      status: (e = s.response) == null ? void 0 : e.status,
      statusText: (t = s.response) == null ? void 0 : t.statusText,
      data: {
        errorCode: s.response.data.errorCode,
        message: s.response.data.message,
        additionalData: s.response.data.additionalData
      }
    }
  };
}
function d(s) {
  var e, t;
  return {
    message: s.message,
    code: s.code,
    response: {
      status: (e = s.response) == null ? void 0 : e.status,
      statusText: (t = s.response) == null ? void 0 : t.statusText
    }
  };
}
function u(s) {
  return {
    message: s.message,
    code: s.code,
    additionalData: s.additionalData
  };
}
function m(s) {
  return {
    message: s.message
  };
}
function l(s) {
  var e;
  if (n(s))
    return o(s);
  if (a(s))
    return d(s);
  if (i(s) && s.message)
    return u(s);
  if (s instanceof Error || (e = s == null ? void 0 : s.message) != null && e.length)
    return m(s);
  throw new Error("Failed to serialize error");
}
export {
  l as default
};
